// src/components/task/TaskIndex.tsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { TaskForm } from './TaskForm';
import { TaskList } from './TaskList';
import AboutSection from '../../AboutSection'; // adjust the path as needed
import ProjectTaskDashboard from './ProjectTaskDashboard';
import ProjectTaskKpiDashboard from './ProjectTaskKpiDashboard';

const isAdmin = true; // You can dynamically derive this based on auth context or props

const TaskFormWrapper: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let mode: 'create' | 'edit' | 'view' = 'view';
  if (pathname.endsWith('/create')) mode = 'create';
  else if (pathname.endsWith('/edit')) mode = 'edit';

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col w-full p-2">
      <AboutSection title={`Tasks - ${mode}`} iconName="tasks" />
      <TaskForm mode={mode} />
    </div>
  );
};

const TasksModule: React.FC = () => {
  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<ProjectTaskKpiDashboard />} />
      <Route path="list" element={<TaskList />} />
      <Route path="create" element={<TaskFormWrapper />} />
      <Route path=":id" element={<TaskFormWrapper />} />
      <Route path=":id/edit" element={<TaskFormWrapper />} />
    </Routes>
  );
};

export default TasksModule;